import React from 'react'
import './UserHeader.css'

export default function UserHeader({ user, gameName = 'TETRIS' }) {
  return (
    <div className="game-header">
      <div className="user-info">
        {user?.photoURL ? (
          <img src={user.photoURL} alt="User" className="user-photo" />
        ) : (
          <div className="user-photo user-photo-placeholder">
            {(user?.displayName || user?.email || 'U').charAt(0).toUpperCase()}
          </div>
        )}
        <span className="user-name">{user?.displayName || user?.email || 'Usuário'}</span>
      </div>
      <h1 className="game-title">{gameName}</h1>
      <div className="header-spacer"></div>
    </div>
  )
}
